module.exports = __webpack_public_path__ + "img/hopital-montfort.0b5ef17e.webp";